import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { taskManagerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const CreateDispute = () => {

  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tastManager;
  const contract = taskManagerContract(tokenAddress, web3);

  //This hook for dispute and 2 is parameter
  const createDisputeHook = useCallback(
    async (disputeSign, taskData, creatorIpfsURI) => {
      console.log(disputeSign, 'DisputeSign 5 in hook', taskData);
      
      const isoTime = taskData?.coolDownPeriod;
      const date = new Date(isoTime);
      const milliseconds = date.getTime();
      const disputeEndTimeseconds = Math.floor(milliseconds / 1000);
      console.log(disputeEndTimeseconds, "seconds disputeEndTime");
      console.log("dispute payload", creatorIpfsURI, '----', disputeSign?.taskId, disputeSign?.deadline, disputeSign?.winnerAddress, creatorIpfsURI? `ipfs://${creatorIpfsURI}/` : disputeSign?.winnerIpfsUrl, disputeSign?.signerSignature, disputeSign?.ipfsUrl, disputeEndTimeseconds);

      try {
        var gasFunPrice;
        web3.eth.getGasPrice().then((result) => {
          var result2 = parseInt(result)
          gasFunPrice = result2.toString()
        })
        const gas = await contract.methods.disputeTask(disputeSign?.taskId, disputeSign?.deadline, disputeSign?.winnerAddress, creatorIpfsURI ? `ipfs://${creatorIpfsURI}/` : disputeSign?.winnerIpfsUrl, disputeSign?.signerSignature, disputeSign?.ipfsUrl, disputeEndTimeseconds).estimateGas({
          from: account
        });
        const details = await contract.methods.disputeTask(disputeSign?.taskId, disputeSign?.deadline, disputeSign?.winnerAddress, creatorIpfsURI? `ipfs://${creatorIpfsURI}/` : disputeSign?.winnerIpfsUrl, disputeSign?.signerSignature, disputeSign?.ipfsUrl, disputeEndTimeseconds).send({
          from: account,
          gas,
          gasPrice: gasFunPrice
        });
        return details;
      } catch (error) {
        console.log('errorr', error);

        throw error;
      }
    },
    [contract, account, web3]
  );
  return { createDisputeHook: createDisputeHook };
};
export default CreateDispute;